var $export = require('./$.export')
  , $task   = require('./$.task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/web.immediate.js
 ** module id = 187
 ** module chunks = 1
 **/